export default {
    NAO_INFORMADO: 1,
    NAO_RETIRADO: 2,
    RETIRADO: 3,
}